import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"container\">\n  {{html-safe this.model}}\n</div>",{ moduleName: "discourse/templates/unknown.hbs" })